import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-132">
      <div className="bg-[#1e2738] rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden flex flex-col ring-1 ring-white/10" onClick={e => e.stopPropagation()} data-id="element-133">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-[#2d3e50]" data-id="element-134">
          <h2 id="modal-title" className="text-2xl md:text-3xl font-bold text-[#e8edf4]" data-id="element-135">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-[#2a3447] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a8b5d1]/30" aria-label="Cerrar modal" data-id="element-136">
            <XIcon className="w-6 h-6 text-[#d1d9e6]" data-id="element-137" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 md:p-8" data-id="element-138">
          <div className="prose prose-lg max-w-none text-[#d1d9e6] prose-headings:text-[#e8edf4] prose-strong:text-[#e8edf4] prose-a:text-[#a8b5d1]" data-id="element-139">
            {children}
          </div>
        </div>
      </div>
    </div>;
}